<template>
  <div>
    <customCommon :customFlag="true" :btnFlg= 'btnFlg'></customCommon>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import customCommon from '@/views/newTMS/basicSettings/components/customCommon.vue'
export default {
  components: {
    customCommon
  },
  data () {
    return {
      btnFlg: [],
      btnIdArr: ['01N0080100', '01N0080200', '01N0080300', '01N0080400', '01N0080500']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/customTMS')
  },
  methods: {

  }
}
</script>
<style scoped lang='less'>

</style>
